import React from "react";

const IconRoute = ({ ...rest }) => (
	<svg
		width="8px"
		height="36px"
		viewBox="0 0 8 36"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		{...rest}
	>
		<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			<g>
				<path
					d="M4,36 C6.209139,36 8,34.209139 8,32 C8,29.790861 6.209139,28 4,28 C1.790861,28 0,29.790861 0,32 C0,34.209139 1.790861,36 4,36 Z M4,34 C2.8954305,34 2,33.1045695 2,32 C2,30.8954305 2.8954305,30 4,30 C5.1045695,30 6,30.8954305 6,32 C6,33.1045695 5.1045695,34 4,34 Z"
					fill="#2B82B2"
					fillRule="nonzero"
				></path>
				<path
					d="M4,10 L4,26"
					stroke="#2B82B2"
					strokeLinecap="square"
					strokeDasharray="3"
				></path>
				<path
					d="M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C2.8954305,6 2,5.1045695 2,4 C2,2.8954305 2.8954305,2 4,2 C5.1045695,2 6,2.8954305 6,4 C6,5.1045695 5.1045695,6 4,6 Z"
					fill="#2B82B2"
					fillRule="nonzero"
				></path>
			</g>
		</g>
	</svg>
);

export default IconRoute;
